import React from 'react';
import useStyles from './styles';
import ReactLoading from "react-loading";

function Loading({className, size, color}) {
  const c = useStyles();

  return (
    <div className={c.container + " " + (className || "")}>
      <ReactLoading type={"spin"} color={color || "#004f9f"} height={size || 64} width={size || 64} ></ReactLoading>
    </div>
  );
}

export default Loading;